import './App.css';
import NavAuth from './Components/NavAuth';
import { Route, Routes } from 'react-router-dom';
import Home from './Components/Home';
import Register from './Components/Register';
import Login from './Components/Login';
import Profil from './Components/Profil';
import PrivateRoute from './Components/PrivateRoute';
import Errors from './Components/Errors';
import ListUser from './Components/ListUser';
import UpdateUser from './Components/UpdateUser';
import UpdateProfil from './Components/UpdateProfil';
import Requests from './Components/Requests';
import AddRequests from './Components/AddRequest';
import NProfil from './Components/NProfil';
import Rapports from './Components/Rapports';
import RapportsTwin from './Components/RapportsTwin';
import HumanResources from './Components/HumanResources';
import ListRapports from './Components/ListRapports';
import ListeRapportsTwin from './Components/ListeRapportsTwin';
import CheckListMC from './Components/CheckListMC';
import MyQuizs from './Components//MyQuizs';
import CollecteTwin from './Components/CollecteTwin';
import ApplicationFakhry from './Components/ApplicationFakhry';
import HumanRessourcesList from './Components/HumanRessourcesList';
import GestionHeuresSupp from './Components/GestionHeuresSupp';
import GestionHR from './Components/GestionHR';
import ListCollectTwin from './Components/ListCollectTwin';
import MyEmploi from './Components/MyEmploi';
import HomeGraph from './Components/HomeGraph';
import AddQuiz from './Components/AddQuiz';
import QuizDescription from './Components/QuizDescription';
import ReponseQuiz from './Components/ReponseQuiz';
import QuizGroupedResponse from './Components/QuizGroupedResponse';
import Welcome from './Components/Welcome';
import ReponseAllHS from './Components/RsponseAllHS';
import FichePaie from './Components/FichePaie';
import RapportsSpintoss from './Components/RapportsSpintoss';
import ListRapportsSpintoss from './Components/ListRapportsSpintoss';
import Accueil from './Components/Accueil';
import ChargeExp from './Components/ChargeExp';
import ListChargeExp from './Components/ListChargeExp';
import SupplierForm from './Components/SupplierForm';
import IngredientForm from './Components/IngredientForm';
import InvoiceForm from './Components/InvoiceForm';
import StockReport from './Components/StockReport';
import TechnicalSheet from './Components/TechnicalSheet';
import ListTechnicalSheets from './Components/ListTechnicalSheets';
import InvoiceList from './Components/InvoiceList';
import Menu from './Components/Menu';
import ProductManager from './Components/ProductManager';
import Addition from './Components/Addition';
import BillsFilter from './Components/BillsFilter';
import UpdateStock from './Components/UpdateStock';
import StockDifference from './Components/StockDifference';
import KitchenOrder from './Components/KitchenOrder';
import BeverageOrder from './Components/BeverageOrder';
import TimeOrder from './Components/TimeOrder';
import TimeCheck from './Components/TimeCheck';
import SubTechnicalSheet from './Components/SubTechnicalSheet';
import Deals from './Components/Deals';
import DailyClosure from './Components/DailyClosure';
import Marge from './Components/Marge';
import StaffAdditionsReport from './Components/StaffAdditionsReport';
import TicketCaisseS from './Components/TicketCaisseS';
import GlobalClosure from './Components/GlobalClosure';
import ConfigurationManager from './Components/ConfigurationManager';
import ConfigInterface from './Components/ConfigInterface';
import MenuWrapper from './Components/MenuWrapper';
import CardRegistration from './Components/CardRegistration';
import BestSell from './Components/BestSell';
import PointsGestion from './Components/PointsGestion';
import QRCodeScanner from './Components/QRCodeScanner';
import InvoiceLIst from './Components/InvoiceList';
import StockReportUser from './Components/StockReportUser';
import DailyInventory from './Components/daily-inventory';
import InventoryComparison from './Components/inventory-comparison';
import DailyInventoryAdmin from './Components/daily-inventory-admin';
import StockDashboard from './Components/inventory-comparison';
import PerformanceDashboard from './Components/PerformanceDashboard';
import AdminExpensesManager from './Components/AdminExpensesManager';





function App() {
  return (
    <div>
      
      <NavAuth/>
        <Errors/>
      <Routes>
        
            <Route path='/Home' element={<Home/>}/>
            <Route path='/Accueil' element={<Accueil/>}/>
            <Route path='/Welcome' element={<Welcome/>}/>
            <Route path='/Register' element={<Register/>}/>
            <Route path='/Login' element={<Login/>}/>
            <Route path='/Profil' element={<PrivateRoute><NProfil/></PrivateRoute>}/>
            <Route path='/AllUser' element ={<ListUser/>}/>
            <Route path='/UpdateUser/:id' element ={<UpdateUser/>}/>
            <Route path='/UpdateProfil' element ={<UpdateProfil/>}/>
            <Route path='/Requests' element ={<Requests/>}/>
            <Route path='/AddRequests' element ={<AddRequests/>}/>
            <Route path='/AddRapports' element = {<Rapports/>}/>
            <Route path='/AddRapportsTwin' element = {<RapportsTwin/>}/>
            <Route path='/HumanResources' element = {<HumanResources/>}/>
            <Route path='/ListRapport' element={<ListRapports/>}/>
            <Route path='/ListeRapportTwin' element={<ListeRapportsTwin/>}/>
            <Route path='/CLManarCity' element={<CheckListMC/>}/>
            <Route path='/AddQuiz' element={<AddQuiz/>}/>
            <Route path='/MyQuizs' element={<MyQuizs/>}/>
            <Route path='/CollecteTwin' element={<CollecteTwin/>}/>
            <Route path='/ListeCollecteTwin' element={<ListCollectTwin/>}/>
            <Route path='/ApplicationFakhry' element={<ApplicationFakhry/>}/>
            <Route path='/HumanRessourcesList' element={<HumanRessourcesList/>}/>
            <Route path='/GestionHeuresSupp' element={<GestionHeuresSupp/>}/>
            <Route path='/GestionHR' element={<GestionHR/>}/>
            <Route path='/MyEmploi' element={<MyEmploi/>}/>
            <Route path='/HomeGraph' element={<HomeGraph/>}/>
            <Route path='/QuizDescription/:id' element={<QuizDescription/>}/>
            <Route path='/ReponseQuiz/:id' element={<ReponseQuiz/>}/>
            <Route path='/QuizGroupedResponse/:id' element={<QuizGroupedResponse/>}/>
            <Route path='/QuizGroupedResponse/:id' element={<QuizGroupedResponse/>}/>
            <Route path='/GestionAllHR' element={<ReponseAllHS/>}/>
            <Route path='/FichePaie' element={<FichePaie/>}/>
            <Route path='/AddRapportsSpintoss' element = {<RapportsSpintoss/>}/>
            <Route path='/ListRapportsSpintoss' element={<ListRapportsSpintoss/>}/>
            <Route path='/AddChargeExp' element = {<ChargeExp/>}/>
            <Route path='/ListChargeExp' element={<ListChargeExp/>}/>
            <Route path='/AjoutFrs' element={<SupplierForm/>}/>
            <Route path='/AjoutIngredient' element={<IngredientForm/>}/>
            <Route path='/AjoutFacture' element={<InvoiceForm/>}/>
            <Route path='/ApercuStock' element={<StockReport/>}/>
            <Route path='/ApercuStockUser' element={<StockReportUser/>}/>
            <Route path='/InvoiceList' element={<InvoiceList/>}/>
            <Route path='/TechnicSheet' element={<TechnicalSheet/>}/>
            <Route path='/SubTechnicSheet' element={<SubTechnicalSheet/>}/>
            <Route path='/ListTechnicSheet' element={<ListTechnicalSheets/>}/>
            <Route path='/ListProduct' element={<Menu/>}/>
            <Route path='/ProductM' element={<ProductManager/>}/>
            <Route path='/Addition' element={<Addition/>}/>
            <Route path='/TicketReport' element={<BillsFilter/>}/>
            <Route path='/UpdateStock' element={<UpdateStock/>}/>
            <Route path='/StockDifference' element={<StockDifference/>}/>
            <Route path='/KitchenOrder' element={<KitchenOrder/>}/>
            <Route path='/BeverageOrder' element={<BeverageOrder/>}/>
            <Route path='/TimeOrder' element={<TimeOrder/>}/>
            <Route path='/TimeCheck' element={<TimeCheck/>}/>
            <Route path='/Deals' element={<Deals/>}/>
            <Route path='/Cloture' element={<DailyClosure/>}/>
            <Route path='/Margespin' element={<Marge/>}/>
            <Route path='/ticketpersonnel' element={<StaffAdditionsReport/>}/>
            <Route path='/TicketCaisseS' element={<TicketCaisseS/>}/>
            <Route path='/GlobalClosure' element={<GlobalClosure/>}/>
            <Route path='/ConfigManager' element={<ConfigurationManager/>}/>
            <Route path='/ConfigInterface' element={<ConfigInterface/>}/>
            <Route path='/MenuWrapper' element={<MenuWrapper/>}/>
            <Route path='/CardRegistration' element={<CardRegistration/>}/>
            <Route path='/BestSell' element={<BestSell/>}/>
            <Route path='/PointsGestion' element={<PointsGestion/>}/>
            <Route path='/QrCodeScanner' element={<QRCodeScanner/>}/>
            <Route path='/AllInvoice' element={<InvoiceLIst/>}/>
            <Route path='/daily-inventory' element={<DailyInventory/>}/>
             <Route path='/inventory-comparison' element={<StockDashboard/>}/>
             <Route path='/daily-inventory-admin' element={<DailyInventoryAdmin/>}/>
             <Route path='/PerformanceDashboard' element={<PerformanceDashboard/>}/>
             <Route path='/AdminExpensesManager' element={<AdminExpensesManager/>}/>
             
             
            
            
            
      </Routes>
    </div>
  );
}

export default App;
